var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPrevArrow = function SvgPrevArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190 -7) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6a.987.987,0,0,0-1,1V22.594L8.719,16.281a1.017,1.017,0,0,0-1.437,1.438l8,8a1.059,1.059,0,0,0,1.438,0l8-8A.963.963,0,0,0,25,17a.987.987,0,0,0-1-1,.961.961,0,0,0-.719.281L17,22.594V7A.987.987,0,0,0,16,6Z",
    transform: "translate(0 164)",
    fillRule: "evenodd"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPrevArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prev_arrow.6add01836ab01884476f65dedf8c8c9b.svg";